import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';
const groups = [{
  title: 'Get in the room',
  line: 'Podcasts, interviews, speaking and content.'
}, {
  title: 'Continue the conversation',
  line: 'Follow-up, clearer calls to action and stronger sales conversations.'
}, {
  title: 'Connect people to the right work',
  line: 'Coaching · Consulting · Speaking · Training · Workshops · Courses · Certification · Advisory · Community · Team implementation',
  emphasize: true
}];

/**
 * Simplified editorial business-payoff — three forms of author leverage.
 * Resting state is fully opaque for contrast (no faded/disabled look).
 */
export function BusinessPayoffV2() {
  return <section className="bg-[#1a2838] px-6 py-12 text-[#faf8f5] md:px-10 md:py-14" data-id="element-614" data-mp="1le9pqudnj4iu">
      <div className="mx-auto max-w-5xl" data-id="element-615" data-mp="e0g437ibwivt">
        <div className="max-w-3xl" data-id="element-616" data-mp="e1hqu98pittd">
          <Reveal data-id="element-617" data-mp="9ycrgfjxb88y">
            <Eyebrow data-id="element-618" data-mp="9xti3n8c9s6j">Author leverage</Eyebrow>
            <h2 className="mt-3 font-serif text-3xl leading-[1.08] text-[#faf8f5] md:text-5xl" data-id="element-619" data-mp="9x1lqa6x3qf7">
              The book keeps working
              <br data-id="element-620" data-mp="2klvwk8sk9fuo" />
              <span className="italic text-[#a8c4bb]" data-id="element-621" data-mp="2kmff9rq1c89r">inside the business.</span>
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-622" data-mp="26mnxrh0b89r0">
              The same ideas help you get in the room, continue the conversation,
              and connect people to the right work.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.05} data-id="element-623" data-mp="1wu8gklwu7p76">
          <div className="mt-10 divide-y divide-white/15 border-y border-white/15" data-id="element-624" data-mp="21mrujjzfsmci">
            {groups.map(g => <div key={g.title} className={`py-5 md:grid md:grid-cols-[minmax(0,16rem)_1fr] md:items-baseline md:gap-10 md:py-6 ${g.emphasize ? 'md:py-7' : ''}`} data-id="element-625" data-mp="1myf2gy3gznna">
                <h3 className={`font-serif leading-snug ${g.emphasize ? 'text-2xl text-[#d4a574] md:text-3xl' : 'text-xl text-[#faf8f5] md:text-2xl'}`} data-id="element-626" data-mp="1rv5m1vehh1dg">
                  {g.title}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-[#faf8f5]/95 md:mt-0 md:text-lg" data-id="element-627" data-mp="1iymx0u9dhxm5">
                  {g.line}
                </p>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-628" data-mp="3fswlrfltg9pr">
          <p className="mx-auto mt-10 max-w-3xl text-center font-serif text-2xl leading-snug text-[#faf8f5] md:text-3xl" data-id="element-629" data-mp="3avmwbzyffy1x">
            That is the opportunity.
            <br data-id="element-630" data-mp="36s85sfcv3za8" />
            <span className="italic text-[#a8c4bb]" data-id="element-631" data-mp="36si02f4xwslq">
              But it is probably not what is happening now.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}